export const site = {
  title: 'Catherine Kimani',
  initials: 'CK',
  url: process.env.REACT_APP_SITE_URL || '',
  description:
    'Catherine Kimani is a software engineer in Nairobi building web applications with Python, Django, React and Vue.js. AWS certified, focused on backend systems and performance.',
}

export const about = {
  name: 'Catherine Kimani',
  role: 'Software Engineer',
  tagline: 'I build fast, accessible web applications that people enjoy using.',
  bio: [
    "I'm a software engineer with two years of experience building and maintaining web applications, with Python and Django on the backend and React or Vue.js on the front. I've shipped and supported production systems in fintech and advisory environments, used by real people rather than demo accounts.",
    'I am AWS certified and most at home in backend work: designing REST APIs, shaping database schemas, and chasing the performance problems that only surface under real load. I lean on Agile practice, code review and containerised environments to ship work I can stand behind.',
  ],
  facts: [
    { label: 'Focus', value: 'Backend systems & full-stack web' },
    { label: 'Location', value: 'Nairobi, Kenya' },
    { label: 'Certified', value: 'AWS re/Start' },
    { label: 'Available', value: 'Full-time roles & freelance' },
  ],
  status: 'Open to new opportunities',
  resume: '',
}

export const social = {
  github: 'https://github.com/catherinekimani',
  linkedin: 'https://www.linkedin.com/in/catherine-kimani/',
  twitter: 'https://twitter.com/ckimani882',
  email: 'catherinekimani882@gmail.com',
}

export const projects = [
  {
    id: 'ai-email-sorter',
    name: 'AI Email Sorter',
    description:
      'A Gmail companion that reads an inbox and does the triage for you: categorising mail, writing short summaries, and clearing out the noise. Built on the Gmail API with an LLM layer for classification and a background queue so long-running jobs never block the request.',
    stack: ['React', 'Node.js', 'Express', 'MongoDB', 'Gmail API', 'OpenAI'],
    sourceCode: 'https://github.com/catherinekimani/ai-email-sorter',
    livePreview: 'https://ai-email-sorter-1.onrender.com',
    featured: true,
  },
  {
    id: 'clean-connect',
    name: 'Clean Connect',
    description:
      'A two-sided marketplace pairing clients with local service providers, covering provider profiles, service listings and the booking flow between them. React front end against a Django REST backend with separate apps for user management and providers.',
    stack: ['React', 'Django', 'Python', 'REST APIs'],
    sourceCode: 'https://github.com/catherinekimani/clean-connect',
    livePreview: '',
    featured: false,
  },
  {
    id: 'sparkhub',
    name: 'SparkHub',
    description:
      'A knowledge-sharing platform where people publish and collaborate on tutorials, guides and other long-form content. This is the React client, covering routing, auth-aware views and the content browsing experience, backed by a Django API.',
    stack: ['React', 'React Router', 'Django', 'CSS'],
    sourceCode: 'https://github.com/catherinekimani/SparkHub-Frontend',
    livePreview: '',
    featured: false,
  },
]

export const experience = [
  {
    id: 'pula-advisors',
    role: 'Software Engineer (Intern)',
    company: 'Pula Advisors',
    shortName: 'Pula Advisors',
    period: 'Nov 2024 - Apr 2025',
    description:
      'At Pula Advisors I developed and deployed Vue.js frontend components for an internal platform serving over 500 users, and built the Django and PostgreSQL REST endpoints behind them, cutting data retrieval time by 30%. I worked in Agile sprints with a five-person team, introduced Docker containerisation to streamline developer onboarding, and configured Prometheus and Grafana dashboards so the team could see how production was actually behaving.',
    stack: ['Vue.js', 'Django', 'PostgreSQL', 'Docker', 'Prometheus', 'Grafana'],
  },
  {
    id: 'e-moti',
    role: 'Backend Software Engineer',
    company: 'E-moti',
    shortName: 'E-moti',
    period: 'Oct 2024 - Dec 2024',
    description:
      'At E-moti I designed and implemented the REST APIs powering a mobile application backend, working in Django REST Framework alongside PostgreSQL schemas and query optimisation that improved API response time by 25%. I documented more than 15 endpoints in Swagger and worked directly with the mobile developers to agree data contracts and specifications, so the Flutter team could integrate without guesswork.',
    stack: ['Django REST Framework', 'Python', 'PostgreSQL', 'Swagger'],
  },
  {
    id: 'italanta-elewa',
    role: 'Software Developer (Intern)',
    company: 'iTalanta / Elewa Open-Source Internship Programme',
    shortName: 'iTalanta',
    period: 'Sep 2022 - Nov 2022',
    description:
      'During the iTalanta and Elewa open-source internship I enhanced Angular frontend components for a learning management system used by more than 200 students. I resolved over 20 UI bugs and shipped responsive design improvements across eight application modules, working inside a collaborative open-source team where every change went through code review and testing.',
    stack: ['Angular', 'TypeScript', 'Responsive UI'],
  },
]

export const skills = [
  {
    id: 'languages',
    title: 'Languages',
    items: ['JavaScript', 'TypeScript', 'Python', 'PHP', 'C', 'HTML', 'CSS'],
  },
  {
    id: 'frontend',
    title: 'Frontend',
    items: ['React', 'Vue.js', 'Angular', 'Responsive UI', 'Accessibility'],
  },
  {
    id: 'backend',
    title: 'Backend & Data',
    items: [
      'Django',
      'Django REST',
      'FastAPI',
      'Flask',
      'Laravel',
      'Node.js',
      'Express',
      'REST APIs',
      'PostgreSQL',
      'MySQL',
      'MongoDB',
    ],
  },
  {
    id: 'devops',
    title: 'DevOps & Tools',
    items: [
      'AWS',
      'Docker',
      'Linux',
      'Ansible',
      'Git',
      'CI/CD',
      'Agile',
      'Testing',
    ],
  },
]

export const navLinks = [
  { id: 'about', label: 'About' },
  { id: 'experience', label: 'Experience' },
  { id: 'projects', label: 'Projects' },
  { id: 'skills', label: 'Skills' },
  { id: 'contact', label: 'Contact' },
]
